import styled, { css } from 'styled-components';
import { layout } from 'src/components/base';
import { Row } from '@prisjakt/ui/list/variants';
import { BodySmallText, CaptionText } from '@prisjakt/ui/text/variants';
import { Clickable } from 'src/components/clickable';
import MagnifyIcon from 'mdi-react/MagnifyIcon';

type ListItemProps = {
  order?: number;
  $selected: boolean;
};

const ITEM_HEIGHT = '40px';

export const ListItemButton = styled(Clickable)`
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: space-between;
  text-align: left;
  height: ${ITEM_HEIGHT};
  padding-left: ${layout.measurements.spacing100};
  padding-right: ${layout.measurements.spacing100};
  opacity: ${p => (p.disabled ? 0.3 : 1)};
  width: 100%;
  transition: background-color 150ms ease;
  color: ${p => p.theme.text.primary};

  &:hover {
    background-color: ${p => p.theme.colors.base200};
  }

  > *:not(:last-child) {
    margin-right: ${layout.measurements.spacing050};
  }
`;

const selectedStyles = css`
  ${ListItemButton} {
    background-color: rgba(72, 149, 182, 0.1);
  }
`;

export const ListItem = styled.li<ListItemProps>`
  order: ${p => p.order || 1};
  ${p => p.$selected && selectedStyles};
  position: relative;
`;

export const SubListItem = styled(ListItem)`
  && {
    ${p =>
      p.$selected &&
      css`
        background: transparent;
      `};
  }

  ${ListItemButton} {
    /* suggestions gutter + icon size + icon spacing */
    padding-left: 2.5rem;
    height: 30px;
  }
`;

export const Wrapper = styled(Row).attrs({ gap: 0.5 })`
  align-items: center;
`;

export const Labels = styled(Row).attrs(p => ({ gap: p.gap || 0.5 }))`
  && {
    align-items: baseline;
    flex: 0 1 auto;
  }
`;

export const NameLabel = styled(BodySmallText)`
  flex: 0 1 auto;
`;

export const SectionLabel = styled(CaptionText)`
  flex: 1 0 auto;
  align-self: baseline;
`;

export const SearchIcon = styled(MagnifyIcon)`
  color: ${p => p.theme.icons.secondary};
`;

export const ShopLogo = styled.img`
  max-height: 24px;
  margin-left: auto;

  /* stylelint-disable-next-line value-no-vendor-prefix */
  image-rendering: -webkit-optimize-contrast;
`;
